import * as React from "react"
import { Box } from "@chakra-ui/react"
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"

import BikesMapContainer from "../components/BikesMapContainer"
import { useOrgs } from "../components/providers/OrgProvider"
import { useLocalStorage } from "../lib/hooks/useLocalStorage"
import { BIKE_STATES_KEY, BIKE_MODELS_KEY, BIKE_MAP_KEY, BIKE_TAGS_KEY } from "../lib/config"
import { BikeState } from "../lib/types/bike"
import { BikesTable } from "../components/BikesTable"
import { BikesTopbar } from "../components/BikesTopbar"
import { useDocumentTitle } from "../lib/hooks/useDocumentTitle"

dayjs.extend(relativeTime)

export const Bikes = () => {
  useDocumentTitle("Assets")

  const { currentOrgs } = useOrgs()
  const [search, setSearch] = React.useState("")
  const [bikeStates, setBikeStates] = useLocalStorage<BikeState[]>(BIKE_STATES_KEY, [
    "available",
    "in_maintenance",
    "rented",
  ])
  const [bikeModels, setBikeModels] = useLocalStorage<string[]>(BIKE_MODELS_KEY, [])
  const [bikeTags, setBikeTags] = useLocalStorage<string[]>(BIKE_TAGS_KEY, [])
  const [mapView, setMapView] = useLocalStorage<boolean>(BIKE_MAP_KEY, true)
  const [requiresRefresh, setRequiresRefresh] = React.useState(0)

  // workaround for bikes refresh after create
  const handleForceRefresh = () => {
    setRequiresRefresh((v) => ((v + 1) % 9999 > 0 ? (v + 1) % 9999 : 1))
  }

  React.useEffect(() => {
    setBikeModels([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrgs])

  const bikeProps = { search, bikeStates, bikeModels, bikeTags }
  return (
    <Box>
      <BikesTopbar
        forceRefresh={handleForceRefresh}
        {...bikeProps}
        {...{ setSearch, setBikeStates, setBikeModels, setBikeTags, mapView, setMapView }}
      />
      {mapView ? (
        <BikesMapContainer {...bikeProps} />
      ) : (
        <BikesTable {...bikeProps} requiresRefresh={requiresRefresh} />
      )}
    </Box>
  )
}
